"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = _interopRequireDefault(require("immutable"));

var _GraderAPI = _interopRequireDefault(require("../api/GraderAPI"));

var _AppConstants = _interopRequireDefault(require("../constants/AppConstants"));

var _Paths = require("../constants/Paths");

var _History = require("../util/History");

var _contactTracker = _interopRequireDefault(require("../lib/contactTracker"));

var _Contact = require("../selectors/Contact");

var Actions = _AppConstants.default.ActionTypes;
var graderAPI = new _GraderAPI.default();
var _default = {
  getGrade: function getGrade(websiteUrl) {
    var _this = this;

    return function (dispatch, getState) {
      var email = (0, _Contact.getEmail)(getState());
      dispatch({
        type: Actions.GRADE_WEBSITE_POLLING,
        payload: {
          websiteUrl: websiteUrl
        }
      });
      graderAPI.get(websiteUrl).then(function (response) {
        if (response.status === 200) {
          var websiteGrade = _immutable.default.fromJS(response.responseJSON);

          dispatch({
            type: Actions.WEBSITE_GRADED,
            payload: websiteGrade
          });

          if (email) {
            _contactTracker.default.saveContact(email, websiteGrade);
          }
        }
      }, function (response) {
        if (response.status === 404) {
          dispatch(_this.gradeWebsite(websiteUrl));
        } else {
          var errorType = response.responseJSON.errorType;
          dispatch({
            type: Actions.WEBSITE_GRADED_ERROR,
            payload: {
              websiteUrl: websiteUrl,
              errorType: errorType
            }
          });
          (0, _History.replace)(_Paths.ERROR + "/" + errorType);
        }
      });
    };
  },
  gradeWebsite: function gradeWebsite(websiteUrl) {
    return function (dispatch) {
      dispatch({
        type: Actions.GRADE_WEBSITE,
        payload: {
          websiteUrl: websiteUrl
        }
      });
      graderAPI.post(websiteUrl).then(function (response) {
        if (response.status >= 200 && response.status < 300) {
          dispatch({
            type: Actions.GRADE_WEBSITE_POLLING
          });
        }
      }, function () {
        dispatch({
          type: Actions.WEBSITE_GRADED_ERROR,
          payload: {
            websiteUrl: websiteUrl
          }
        });
        (0, _History.replace)(_Paths.ERROR);
      });
    };
  },
  storeContact: function storeContact(contactEmail) {
    return function (dispatch) {
      dispatch({
        type: Actions.STORE_CONTACT,
        payload: {
          contactEmail: contactEmail
        }
      });
    };
  },
  resultsPageUnmounted: function resultsPageUnmounted() {
    return {
      type: Actions.RESULTS_PAGE_UNMOUNTED
    };
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/actions/GraderActionCreator.js
// module id = 97
// module chunks = 0